// Demo environment for the per-env demo stack (public + internal names).
//
// Same contract as the sandbox variant: every endpoint resolves from the
// browser location, so ONE image works behind https://<env>.testing.mypacs.vet
// (authentik gate → Coolify proxy → nginx) AND http(s)://<env>.demo.internal
// (internal route → nginx). Copied over environment.test.ts by
// scripts/build-demo-images.sh before `npm run build-test`.
//
// Routing contract (configs/nginx/nginx-demo.conf):
//   /api    -> api container (prefix stripped)
//   /pacs   -> orthanc-open (prefix stripped)
//   /ohif   -> ohif viewer
import type { Environment } from './environment.interface';

const origin = window.location.origin;
const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

export const environment: Environment = {
  name: 'demo',
  production: false,
  mock: false,
  apiUrl: `${origin}/api`,
  orthancUrl: `${origin}/pacs`,
  ohifUrl: `${origin}/ohif`,
  orthancLocalPort: 8082,
  apiWsUrl: `${wsProtocol}://${window.location.host}/api/graphql`,
  displayedStudiesCount: 12,
  pingInterval: 60000,
  studyUploadingRefreshInterval: 30000,
  mode: 'mypacs',
  allowSccUpload: true,
  zendeskKey: '',
};
